module.exports = __webpack_public_path__ + "mainassets/img/helpform.cfa518de.svg";